import { Button } from "components/ui/button";
import { MinusIcon, PlusIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { Color } from "utils/theme";

export interface NumberInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: any;
  onValueChange: (value: number) => void;
}

export const NumberInput = ({ onValueChange, ...props }: NumberInputProps) => {
  const { error, disabled } = props;
  const [value, setValue] = useState(Number(props.defaultValue) ?? 0);

  const handleIncrement = () => {
    setValue((prev) => Math.min(prev + Number(props.step), Number(props.max)));
  };

  const handleDecrement = () => {
    setValue((prev) => Math.max(prev - Number(props.step), Number(props.min)));
  };

  useEffect(() => {
    onValueChange(value);
  }, [value]);

  return (
    <div>
      <div
        className="flex items-center rounded-lg overflow-hidden border"
        style={{ borderColor: Color.Primary[600] }}
      >
        <Button
          className="w-12 h-12 text-xl rounded-none border-0 border-r"
          variant="secondary"
          onClick={handleDecrement}
        >
          <MinusIcon className="size-5" strokeWidth={2.5} />
        </Button>
        <input
          id={props?.name}
          name={props?.name}
          type="number"
          className={
            "flex-1 min-w-[70px] shrink-0 text-center text-base block w-full px-2.5 h-12 text-white focus:outline-none"
          }
          style={{ background: Color.Primary[700] }}
          disabled={disabled}
          onChange={(e) => setValue(Number(e.target.value))}
          value={value}
          min={props.min}
          max={props.max}
        />
        <Button
          className="w-12 h-12 text-xl rounded-none border-0 border-l"
          variant="secondary"
          onClick={handleIncrement}
        >
          <PlusIcon className="size-5" strokeWidth={2.5} />
        </Button>
      </div>
      {error && (
        <span
          className="text-sm font-semibold"
          style={{
            color: Color.Rose[500],
          }}
        >
          {error?.message?.toString()}
        </span>
      )}
    </div>
  );
};
